import { TransformWithLVS } from './TransformWithLVS';
export function ToBoolean(options = {}, transformOptions) {
    const { ignoreUndefined = false, ignoreNull = false } = options;
    return TransformWithLVS(({ value }) => {
        if (ignoreUndefined && value === undefined) {
            return undefined;
        }
        if (ignoreNull && value === null) {
            return null;
        }
        return value === 'true' || value === true || value === 1 || value === '1';
    }, transformOptions);
}
//# sourceMappingURL=ToBoolean.js.map